/*eslint-disable */
import LayerService from '@/services/layers/LayerService';

import store from '@/store/index';

import {
  LayerGroup, LeafletEvent, Marker,
} from 'leaflet';
import { IModalData } from '@/services/layers/IModalData';

export default class ParkingZoneLayerService extends LayerService {
  markerIcon = 'strefy-parkowania.svg';

  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const template: string = metaData.description;

    const modalData: IModalData = {
      title: metaData.name,
      content: template,
      navigationPoint: leafletMarker,
      lastUpdate: '',
      icon: this.markerIcon,
      hideModalBtn: true,
    };

    store.commit('displayModal', modalData);
  };

  redrawLayer = (): LayerGroup<any> => {
    const { parkingZones } = store.state;
    return this.generatePolygonsLayer(parkingZones);
  };
}
